const Preparelessons = () => import("@/page/preparelessons");
const prelessons = () => import("@/page/prelessons/main");
const ExercisePage = () => import("@/page/prelessons/exercisePage");
const creationTest = () => import("@/page/prelessons/creationTest");


export default {
  path: "/Preparelessons",
  component: Preparelessons,
  children:[ {
      path: 'prelessons',
      name: 'prelessons',
      component:prelessons,
    },{
	path:'execrise',
	name:'execrise',
	component:ExercisePage
},{
	path:'creationtest',
	name:'creationtest',
	component:creationTest
}]

};


// WEBPACK FOOTER //
// ./src/router/prelessons.js